import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import MarvieLanding from "./components/MarvieLanding";
import PricelistPage from "./components/PricelistPage";
import { ClinicPickerProvider } from "./components/ClinicPicker";

function App() {
  return (
    <BrowserRouter>
      <ClinicPickerProvider>
        <Routes>
          <Route path="/" element={<MarvieLanding />} />
          <Route path="/pricelist" element={<PricelistPage />} />
        </Routes>
      </ClinicPickerProvider>
    </BrowserRouter>
  );
}

export default App;
